// Get device information
var BrowserDetect = {
    init: function () {
        this.browser = this.searchString(this.dataBrowser) || "Other";
        this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "Unknown";
    },
    searchString: function (data) {
        for (var i = 0; i < data.length; i++) {
            var dataString = data[i].string;
            this.versionSearchString = data[i].subString;

            if (dataString.indexOf(data[i].subString) !== -1) {
                return data[i].identity;
            }
        }
    },
    searchVersion: function (dataString) {
        var index = dataString.indexOf(this.versionSearchString);
        if (index === -1) {
            return;
        }

        var rv = dataString.indexOf("rv:");
        if (this.versionSearchString === "Trident" && rv !== -1) {
            // return parseFloat(dataString.substring(rv + 3));
            return dataString.substring(rv + 3);
        } else {
            // return parseFloat(dataString.substring(index + this.versionSearchString.length + 1));
            return dataString.substring(index + this.versionSearchString.length + 1);
        }
    },

    dataBrowser: [
        {string: navigator.userAgent, subString: "Edg", identity: "MS Edge"},
        {string: navigator.userAgent, subString: "MSIE", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Trident", identity: "Explorer"},
        {string: navigator.userAgent, subString: "Firefox", identity: "Firefox"},
        {string: navigator.userAgent, subString: "Opera", identity: "Opera"},  
        {string: navigator.userAgent, subString: "OPR", identity: "Opera"},  
        {string: navigator.userAgent, subString: "Chrome", identity: "Chrome"}, 
        {string: navigator.userAgent, subString: "Safari", identity: "Safari"}       
    ]
};

var utilsDeviceInfo = (function(window, document) {
    function getDeviceCategory() {
        var ua = navigator.userAgent;
        if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
          return "Tablet";
        }
        if (/Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
          return "Mobile";
        }
        return "Desktop";
    };
    
    function getRequestingPlatform() {
        var userAgent = navigator.userAgent;
        var platform = navigator.platform;
        var macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
        var windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
        var iosPlatforms = ['iPhone', 'iPad', 'iPod'];
        var reqPlatform = null;
      
        if (macosPlatforms.indexOf(platform) !== -1) {
            reqPlatform = 'None';
        } else if (iosPlatforms.indexOf(platform) !== -1) {
            reqPlatform = 'Mobile Site';
        } else if (windowsPlatforms.indexOf(platform) !== -1) {
            reqPlatform = 'None';
        } else if (/Android/.test(userAgent)) {
            reqPlatform = 'Mobile Site';
        } else if (/Linux/.test(platform)) {
            reqPlatform = 'None';
        }
      
        return reqPlatform;
    };
    
    function ipFormated(str) {
        var strArray = str.split('.');
        var indexNewValue = strArray.length - 1;
        var indexOriginalValue = str.lastIndexOf('.');
        var valToSub = str.slice(indexOriginalValue + 1);
        var mask = 'X'.repeat(valToSub.length);
        strArray[indexNewValue] = mask;
        var result = strArray.join('.');
        return result;
    };

    function getOSType(){
        var nAgt = navigator.userAgent;
    
        // Looking for OS
        var os = 'unknown';
        var clientStrings = [
            {s:'Windows 3.11', r:/Win16/},
            {s:'Windows 95', r:/(Windows 95|Win95|Windows_95)/},
            {s:'Windows ME', r:/(Win 9x 4.90|Windows ME)/},
            {s:'Windows 98', r:/(Windows 98|Win98)/},
            {s:'Windows CE', r:/Windows CE/},
            {s:'Windows 2000', r:/(Windows NT 5.0|Windows 2000)/},
            {s:'Windows XP', r:/(Windows NT 5.1|Windows XP)/},
            {s:'Windows Server 2003', r:/Windows NT 5.2/},
            {s:'Windows Vista', r:/Windows NT 6.0/},
            {s:'Windows 7', r:/(Windows 7|Windows NT 6.1)/},
            {s:'Windows 8.1', r:/(Windows 8.1|Windows NT 6.3)/},
            {s:'Windows 8', r:/(Windows 8|Windows NT 6.2)/},
            {s:'Windows NT 4.0', r:/(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/},
            {s:'Windows ME', r:/Windows ME/},
            {s:'Android', r:/Android/},
            {s:'Open BSD', r:/OpenBSD/},
            {s:'Sun OS', r:/SunOS/},
            {s:'ChromeOS', r:/\bCrOS\b/},
            {s:'Linux', r:/(Linux|X11)/},
            {s:'iOS', r:/(iPhone|iPad|iPod)/},
            {s:'Mac OS X', r:/Mac OS X/},
            {s:'Mac OS', r:/(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/},
            {s:'QNX', r:/QNX/},
            {s:'UNIX', r:/UNIX/},
            {s:'BeOS', r:/BeOS/},
            {s:'OS/2', r:/OS\/2/},
            {s:'Search Bot', r:/(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/}
        ];
    
        for (var id in clientStrings) {
            var cs = clientStrings[id];
            if (cs.r.test(nAgt)) {
                os = cs.s;
                break;
            }
        }

        return os;
    }
    
    function getOsVersion() {
        var nAgt = navigator.userAgent;
        var os = getOSType();

        //Looking for version
        var osVersion = 'unknown';
        
        if (/Windows/.test(os)) {
            osVersion = /Windows (.*)/.exec(os)[1];
        }

        if (nAgt.includes("CrOS")) {
            // To obtain ChromeOS version is looking from Chrome version
            var matchOS = nAgt.match(/Chrome\/([\d.]+)/);
            if (matchOS) {
                osVersion = matchOS[1];
            }
        }
    
        switch (os) {
            case 'Mac OS X':
                osVersion = /Mac OS X (10[\.\_\d]+)/.exec(nAgt)[1];
                break;
    
            case 'Android':
                osVersion = /Android ([\.\_\d]+)/.exec(nAgt)[1];
                break;
    
            case 'iOS':
                osVersion = /OS (\d+)_(\d+)_?(\d+)?/.exec(nAgt);
                osVersion = osVersion[1] + '.' + osVersion[2] + '.' + (osVersion[3] | 0);
                break;
    
        }
    
        function formatOS(str) {
            return str.replaceAll('_', '.');
        }

        return formatOS(osVersion);
    };
    
    function getSystemName() {
        return getOSType();
    }
    
    function getGadgetInfo() {
        var ipValue = $('#client_ip').val();
        BrowserDetect.init();
        var browserVersionArr = BrowserDetect.version.split(' ');
        var browserVersion = browserVersionArr[0];
        // gadget object part V of payload
        var gadget = {
            browserType: BrowserDetect.browser,
            browserVersion: browserVersion,
            deviceCategory: getDeviceCategory(),
            deviceType: navigator.platform,
            ipAddress: ipFormated(ipValue),
            operatingSystem: ((getDeviceCategory() === 'Mobile' || getDeviceCategory() === 'Tablet' ) && (navigator.userAgent.indexOf("Linux") != -1)) ? 'Android' : getSystemName(),
            operatingSystemVersion: getOsVersion(),
            requestingPlatform: getRequestingPlatform()
        }

        return gadget
    }

    return {
        getDeviceCategory: getDeviceCategory,
        getRequestingPlatform: getRequestingPlatform,
        ipFormated: ipFormated,
        getOsVersion: getOsVersion,
        getSystemName: getSystemName,
        getGadgetInfo: getGadgetInfo,
    };

})(window, document);
